module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', [(_vm.loading) ? _c('div', {
    staticClass: "content content-centered"
  }, [_c('pulse-loader')], 1) : _vm._e(), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (!_vm.loading),
      expression: "!loading"
    }],
    staticClass: "content"
  }, [_c('div', {
    staticClass: "box"
  }, [_c('div', {
    staticClass: "box-body"
  }, [_c('div', {
    staticClass: "row"
  }, [(_vm.flash) ? _c('div', {
    staticClass: "flash-message col-md-4 col-md-offset-4 text-center"
  }, [_c('div', {
    staticClass: "alert",
    class: 'alert-' + _vm.flashType
  }, [_vm._v(_vm._s(_vm.flashMessage))])]) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "row",
    attrs: {
      "id": "details"
    }
  }, [_c('vue-form', {
    staticClass: "row",
    attrs: {
      "state": _vm.formstate
    },
    on: {
      "submit": function($event) {
        $event.preventDefault();
        return _vm.onSubmit($event)
      }
    }
  }, [_c('div', {
    staticClass: "col-sm-12"
  }, [_c('div', {
    staticClass: "col-sm-6"
  }, [_c('validate', {
    staticClass: "form-group required-field",
    class: _vm.fieldClassName(_vm.formstate.brand),
    attrs: {
      "auto-label": ""
    }
  }, [_c('label', [_vm._v("Brand")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model.lazy",
      value: (_vm.device.brand),
      expression: "device.brand",
      modifiers: {
        "lazy": true
      }
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text",
      "minlength": "2",
      "name": "brand",
      "required": "",
      "placeholder": "Brand Name"
    },
    domProps: {
      "value": (_vm.device.brand)
    },
    on: {
      "change": function($event) {
        _vm.$set(_vm.device, "brand", $event.target.value)
      }
    }
  }), _vm._v(" "), _c('field-messages', {
    staticClass: "form-control-feedback",
    attrs: {
      "name": "brand",
      "show": "$touched || $submitted"
    }
  }, [_c('div', {
    attrs: {
      "slot": "required"
    },
    slot: "required"
  }, [_vm._v("Brand name is a required field")]), _vm._v(" "), _c('div', {
    attrs: {
      "slot": "pattern"
    },
    slot: "pattern"
  }, [_vm._v("Brand name is invalid")]), _vm._v(" "), _c('div', {
    attrs: {
      "slot": "minlength"
    },
    slot: "minlength"
  }, [_vm._v("Minimum length of brand is 2 character")])])], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "col-sm-6"
  }, [_c('validate', {
    staticClass: "form-group required-field",
    class: _vm.fieldClassName(_vm.formstate.deviceModel),
    attrs: {
      "auto-label": ""
    }
  }, [_c('label', [_vm._v("Model")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model.lazy",
      value: (_vm.device.deviceModel),
      expression: "device.deviceModel",
      modifiers: {
        "lazy": true
      }
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text",
      "name": "deviceModel",
      "required": "",
      "placeholder": "Model"
    },
    domProps: {
      "value": (_vm.device.deviceModel)
    },
    on: {
      "change": function($event) {
        _vm.$set(_vm.device, "deviceModel", $event.target.value)
      }
    }
  }), _vm._v(" "), _c('field-messages', {
    staticClass: "form-control-feedback",
    attrs: {
      "minlength": "3",
      "name": "deviceModel",
      "show": "$touched || $submitted"
    }
  }, [_c('div', {
    attrs: {
      "slot": "required"
    },
    slot: "required"
  }, [_vm._v("Model is a required field")]), _vm._v(" "), _c('div', {
    attrs: {
      "slot": "pattern"
    },
    slot: "pattern"
  }, [_vm._v("Model is invalid")]), _vm._v(" "), _c('div', {
    attrs: {
      "slot": "minlength"
    },
    slot: "minlength"
  }, [_vm._v("Minimum length of model is 3 character")])])], 1)], 1)]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-12"
  }, [_c('div', {
    staticClass: "col-sm-6"
  }, [_c('validate', {
    staticClass: "form-group",
    class: _vm.fieldClassName(_vm.formstate.imei),
    attrs: {
      "auto-label": ""
    }
  }, [_c('label', [_vm._v("IMEI")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model.lazy",
      value: (_vm.device.imei),
      expression: "device.imei",
      modifiers: {
        "lazy": true
      }
    }],
    staticClass: "form-control",
    attrs: {
      "type": "number",
      "name": "imei",
      "minlength": "14",
      "required": "",
      "placeholder": "IMEI"
    },
    domProps: {
      "value": (_vm.device.imei)
    },
    on: {
      "change": function($event) {
        _vm.$set(_vm.device, "imei", $event.target.value)
      }
    }
  }), _vm._v(" "), _c('field-messages', {
    staticClass: "form-control-feedback",
    attrs: {
      "name": "imei",
      "show": "$touched || $submitted"
    }
  }, [_c('div', {
    attrs: {
      "slot": "pattern"
    },
    slot: "pattern"
  }, [_vm._v("IMEI is invalid")]), _vm._v(" "), _c('div', {
    attrs: {
      "slot": "minlength"
    },
    slot: "minlength"
  }, [_vm._v("Minimum 14 number required")])])], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "col-sm-6"
  }, [_c('validate', {
    staticClass: "form-group",
    class: _vm.fieldClassName(_vm.formstate.connectionId),
    attrs: {
      "auto-label": ""
    }
  }, [_c('label', [_vm._v("Connection ID")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model.lazy",
      value: (_vm.device.connectionId),
      expression: "device.connectionId",
      modifiers: {
        "lazy": true
      }
    }],
    staticClass: "form-control",
    attrs: {
      "type": "number",
      "name": "connectionId",
      "minlength": "14",
      "required": "",
      "placeholder": "Connection ID"
    },
    domProps: {
      "value": (_vm.device.connectionId)
    },
    on: {
      "change": function($event) {
        _vm.$set(_vm.device, "connectionId", $event.target.value)
      }
    }
  }), _vm._v(" "), _c('field-messages', {
    staticClass: "form-control-feedback",
    attrs: {
      "name": "connectionId",
      "show": "$touched || $submitted"
    }
  }, [_c('div', {
    attrs: {
      "slot": "pattern"
    },
    slot: "pattern"
  }, [_vm._v("Connection ID is invalid")]), _vm._v(" "), _c('div', {
    attrs: {
      "slot": "minlength"
    },
    slot: "minlength"
  }, [_vm._v("Minimum 14 number required")])])], 1)], 1)]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-12"
  }, [_c('div', {
    staticClass: "col-sm-6"
  }, [_c('validate', {
    staticClass: "form-group required-field",
    class: _vm.fieldClassName(_vm.formstate.deviceId),
    attrs: {
      "auto-label": ""
    }
  }, [_c('label', [_vm._v("Device ID")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model.lazy",
      value: (_vm.device.deviceId),
      expression: "device.deviceId",
      modifiers: {
        "lazy": true
      }
    }],
    staticClass: "form-control required-field",
    attrs: {
      "type": "text",
      "minlength": "3",
      "name": "deviceId",
      "required": "",
      "placeholder": "Device ID"
    },
    domProps: {
      "value": (_vm.device.deviceId)
    },
    on: {
      "change": function($event) {
        _vm.$set(_vm.device, "deviceId", $event.target.value)
      }
    }
  }), _vm._v(" "), _c('field-messages', {
    staticClass: "form-control-feedback",
    attrs: {
      "name": "deviceId",
      "show": "$touched || $submitted"
    }
  }, [_c('div', {
    attrs: {
      "slot": "required"
    },
    slot: "required"
  }, [_vm._v("Device ID is a required field")]), _vm._v(" "), _c('div', {
    attrs: {
      "slot": "pattern"
    },
    slot: "pattern"
  }, [_vm._v("Device ID is invalid")]), _vm._v(" "), _c('div', {
    attrs: {
      "slot": "minlength"
    },
    slot: "minlength"
  }, [_vm._v("Minimum length of Device is 3 character")])])], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "col-sm-6"
  }, [_c('label', {
    attrs: {
      "for": "dateAdded"
    }
  }, [_vm._v("Registration Date")]), _vm._v(" "), _c('validate', {
    staticClass: "form-group required-field",
    class: _vm.fieldClassName(_vm.formstate.dateAdded),
    attrs: {
      "auto-label": ""
    }
  }, [_c('date-picker', {
    attrs: {
      "required": "",
      "id": "dateAdded",
      "lang": "en",
      "name": "dateAdded",
      "input-class": "form-control",
      "width": "100%",
      "use-utc": "true",
      "format": "DD-MM-YYYY"
    },
    model: {
      value: (_vm.device.dateAdded),
      callback: function($$v) {
        _vm.$set(_vm.device, "dateAdded", $$v)
      },
      expression: "device.dateAdded"
    }
  }), _vm._v(" "), _c('field-messages', {
    staticClass: "form-control-feedback",
    attrs: {
      "name": "dateAdded",
      "show": "$touched || $submitted"
    }
  }, [_c('div', {
    attrs: {
      "slot": "required"
    },
    slot: "required"
  }, [_vm._v("Commissioning date is a required field")]), _vm._v(" "), _c('div', {
    attrs: {
      "slot": "pattern"
    },
    slot: "pattern"
  }, [_vm._v("Commissioning date is invalid")])])], 1)], 1)]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-12"
  }, [_c('div', {
    staticClass: "col-sm-6"
  }, [_c('validate', {
    staticClass: "form-group",
    class: _vm.fieldClassName(_vm.formstate.deviceDescription)
  }, [_c('label', [_vm._v("Description")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model.lazy",
      value: (_vm.device.deviceDescription),
      expression: "device.deviceDescription",
      modifiers: {
        "lazy": true
      }
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text",
      "name": "deviceDescription",
      "placeholder": "Description"
    },
    domProps: {
      "value": (_vm.device.deviceDescription)
    },
    on: {
      "change": function($event) {
        _vm.$set(_vm.device, "deviceDescription", $event.target.value)
      }
    }
  })])], 1), _vm._v(" "), _c('div', {
    staticClass: "col-sm-6"
  }, [_c('validate', {
    staticClass: "form-group required-field",
    class: _vm.fieldClassName(_vm.formstate.status),
    attrs: {
      "auto-label": ""
    }
  }, [_c('label', [_vm._v("Status")]), _vm._v(" "), _c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.device.status),
      expression: "device.status"
    }],
    staticClass: "form-control",
    attrs: {
      "required": "",
      "name": "status"
    },
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.$set(_vm.device, "status", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
      }
    }
  }, [_c('option', {
    attrs: {
      "value": "",
      "disabled": ""
    }
  }, [_vm._v("Select Status")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "active"
    }
  }, [_vm._v("Active")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "inactive"
    }
  }, [_vm._v("Inactive")])]), _vm._v(" "), _c('field-messages', {
    staticClass: "form-control-feedback",
    attrs: {
      "name": "status",
      "show": "$touched || $submitted"
    }
  }, [_c('div', {
    attrs: {
      "slot": "required"
    },
    slot: "required"
  }, [_vm._v("Status is a required field")]), _vm._v(" "), _c('div', {
    attrs: {
      "slot": "pattern"
    },
    slot: "pattern"
  }, [_vm._v("Status date is invalid")])])], 1)], 1)])]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-12 text-right"
  }, [_c('router-link', {
    attrs: {
      "to": {
        name: 'Devices'
      }
    }
  }, [_c('button', {
    staticClass: "mr-5 btn btn-default",
    attrs: {
      "type": "button"
    }
  }, [_vm._v("Cancel")])]), _vm._v(" "), _c('button', {
    staticClass: "mr-2 btn bt",
    attrs: {
      "type": "submit",
      "disabled": !(_vm.formstate.$dirty && _vm.formstate.$valid)
    },
    on: {
      "click": _vm.createDevice
    }
  }, [_vm._v("Add Device")])], 1)], 1)])])])])
},staticRenderFns: []}
module.exports.render._withStripped = true
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-hot-reload-api").rerender("data-v-ce3a13c8", module.exports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-ce3a13c8"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/views/device/DeviceCreate.vue
// module id = 2385
// module chunks = 0